
import Header from "../components/header";
import Sidebar from "../components/sidebar";
import WalletRecycleCustomer from "../components/walletRecycle";
import Footer from "../components/footer";

function WalletRecyclePage() {
  return (
    <div>
    <div className='wrapper'>
      <Header />
      <Sidebar /> 
      <WalletRecycleCustomer /> 
    </div>
    <Footer /> 
  </div>
  // <Login/>
  );
}
export default WalletRecyclePage;
